import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {JSX} from "react";
import {useAuth} from "./AuthContext";

/**
 * Route guard component for protecting authenticated routes.
 *
 * - Uses `useAuth()` to check if the user is authenticated.
 * - If not authenticated, redirects to the public welcome (`/welcome`) route,
 *   preserving the current location in state for possible return after login.
 * - If authenticated, renders the provided child component.
 */

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    if (!isAuthenticated) {
        return <Navigate to="/welcome" replace state={{ from: location }} />;
    }
    return children;
}
